export const ItemKind = {
  File: 'file',
  Folder: 'folder',
  Board: 'board',
  External: 'external'
};